import { useState } from 'react'
import {
  Box,
  Checkbox,
  ClickAwayListener,
  FormControlLabel,
  FormGroup,
  Grow,
  IconButton,
  Paper,
  Popper,
  Typography,
} from '@mui/material'
import { DashboardSettingsIcon } from '~/components/icons'
import { useCurrentUser, refreshCurrentUser } from '~/common/use-current-user'
import { useUpdateUser } from '~/api/supabase-mutations'

const DASHBOARD_CARD_FLAGS = [
  { key: 'map_card', label: 'Map card' },
  // { key: 'crop_info_card', label: 'Crop info card' },
  { key: 'task_list_card', label: 'Task list card' },
  { key: 'timeline_card', label: 'Timeline card' },
  { key: 'metrics_card', label: 'Metrics card' },
]

export const DashboardCardsMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { currentUser } = useCurrentUser()
  const { updateUser } = useUpdateUser()

  const open = Boolean(anchorEl)
  const features = currentUser?.features || []

  const getValue = (key) => {
    const entry = features.find(f => key in f)
    return entry ? Boolean(entry[key]) : false
  }

  const handleChange = async (key, checked) => {
    if (!currentUser) return
    const updated = features.map(f => (key in f ? { [key]: checked } : f))
    if (!updated.find(f => key in f)) updated.push({ [key]: checked })
    await updateUser(currentUser.id, { features: updated, updated_at: new Date() }, {
      onSuccess: refreshCurrentUser,
    })
  }

  return (
    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
      <Box>
        <IconButton
          size="small"
          onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}
        >
          <DashboardSettingsIcon />
        </IconButton>
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement="bottom-end"
          transition
          sx={{ zIndex: 1300 }}
        >
          {({ TransitionProps }) => (
            <Grow key={0} timeout={200} {...TransitionProps}>
              <Paper elevation={8} sx={{ p: 1.5, mt: 0.5, minWidth: 170 }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Dashboard Cards
                </Typography>
                <FormGroup>
                  {DASHBOARD_CARD_FLAGS.map(({ key, label }) => (
                    <FormControlLabel
                      key={key}
                      label={label}
                      control={
                        <Checkbox
                          checked={getValue(key)}
                          onChange={(e) => handleChange(key, e.target.checked)}
                          size="small"
                        />
                      }
                      sx={{ width: 'fit-content', m: 0 }}
                    />
                  ))}
                </FormGroup>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Box>
    </ClickAwayListener>
  )
}
